import React, { useEffect, useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, CircularProgress, Card, Typography, IconButton, Chip, Menu, Dialog, DialogTitle, DialogContent, Grid, DialogActions } from "@mui/material";
import axios from "axios";
import CustomLabel from "./CustomLabel";
import { useTheme } from "@emotion/react";
import Cookies from "js-cookie";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup"
import { ReactComponent as CloseIcon } from "assets/close_icon.svg"
import PerfectScrollbar from "react-perfect-scrollbar"
import { containerRef } from "utils/index";
import { Primary } from './Buttons';
import { ChangePipelineInvestorStatus, FetchPipelineStatus } from "api/startup_applications";
import { useToast } from "context/ToastContext";
import { KeyboardArrowDown } from "@mui/icons-material";

const statusOptions = ["New", "Shortlisted", "Selected", "Rejected"];

const CardHeader = ({ title, Actions }) => {
    return <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
        <Typography fontWeight={700} fontSize={"1.25rem"}>
            {title}
        </Typography>
        {Actions && <Actions />}
    </Box>
}

const StatusChange = ({ isLoading, selectedStartupId, handleSubmit, handleClose, statuses = [], statusValue = null }) => {

    const [validationObj, setValidationObj] = React.useState({
        status: Yup.string().required("Status is required"),
    });
    const statusValidationSchema = Yup.object({ ...validationObj });
    const formik = useFormik({
        initialValues: {
            status: statusValue ? statusValue : null,
        },
        validationSchema: statusValidationSchema,
        enableReinitialize: true,
        validateOnChange: true,
        onSubmit: (values) => {
            const payload = {
                "status": values?.status
            }
            handleSubmit({ payload: payload })
        },
    });

    const theme = useTheme();

    const handleChange = (e) => {
        const { name, value } = e.target;
        formik.setValues({ ...formik.values, [name]: value });
    };

    const placeholders = {
        // call_for_money: false,
        status: "Select status",

    };

    return (
        <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit} style={{ gap: '1rem' }}>
                <IconButton
                    sx={{ position: "absolute", top: 10, right: 15, padding: 0 }}
                >
                    <CloseIcon width={40} height={40} onClick={handleClose} />
                </IconButton>
                <DialogTitle sx={{ marginInline: "auto", marginBottom: 1 }}>
                    <Typography
                        sx={{
                            fontSize: "1.5rem",
                            fontWeight: 700,
                            lineHeight: "28px",
                            color: theme.palette.customColors.g300,
                            paddingLeft: "0.5rem",
                            textAlign: 'center'
                        }}
                    >
                        Change Status
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ paddingInline: 0, paddingBottom: 1 }}>
                    <PerfectScrollbar
                        containerRef={containerRef}
                        style={{
                            maxHeight: "calc(-250px + 100dvh)",
                            paddingInline: "1.5rem",
                        }}
                    >
                        <Grid item container xs={12} columnSpacing={2}>
                            <Grid item xs={12}>
                                <CustomLabel>Deal Flow Status</CustomLabel>
                                <Select
                                    name="status"
                                    value={formik.values?.status}
                                    onChange={handleChange}
                                    placeholder={placeholders?.status}
                                    sx={{ marginBottom: "0.5rem" }}
                                    fullWidth
                                >
                                    {statuses?.map((option) => (
                                        <MenuItem value={option?.value}>{option?.label}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                        </Grid>
                    </PerfectScrollbar>
                </DialogContent>
                <DialogActions
                    sx={{ paddingInline: "1.5rem", paddingBottom: "1.5rem" }}
                >
                    {/* <Button onClick={handleClose}>Cancel</Button> */}
                    <Primary
                        type="submit"
                        fullWidth
                        disabled={isLoading}
                        sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
                    >
                        {isLoading ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.2rem'} /> : "Update"}
                    </Primary>
                    {/* <Primary sx={{ background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", width: '100%' }} onClick={handleSave}>Save</Primary> */}
                </DialogActions>
                {/* </Dialog> */}
            </Form>
        </FormikProvider>
    )

}


export default function StartupStatusSelector({ startupId, statuses, refetchListing = () => {

} }) {
    const theme = useTheme()
    const { addToast } = useToast();
    let [investor_id, setInvestorID] = React.useState(Cookies.get("X-ADMIN-ID") || null);
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const [updating, setUpdating] = useState(false);

    const {
        mutateAsync: updateStartupStatusAsync,
        status: updateStartupStatusStatus,
        error: updateStartupStatusError,
        isLoading: isUpdatingStartupStatus,
        data: updateStartupStatusResponse,
    } = ChangePipelineInvestorStatus();

    const [openChangeStatus, setOpenChangeStatus] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(false);

    const handleOpenMenu = (event) => {
        setOpenChangeStatus(true);
        setAnchorEl(event)
    }

    const handleCloseMenu = () => {
        setOpenChangeStatus(false);
        setAnchorEl(null)
    }

    const {
        data,
        isLoading: isLoadingStatus,
        refetch: refetchStatus,
        status: pipeline_status
    } = FetchPipelineStatus({
        id: startupId, investor_id
    })

    // console.log(data?.status, "data")

    //   useEffect(() => {
    //     const fetchStatus = async () => {
    //       try {
    //         const res = await axios.get(`/api/startups/${startupId}`);
    //         setStatus(res.data.status || "New");
    //       } catch (err) {
    //         console.error("Error fetching status", err);
    //       } finally {
    //         setLoading(false);
    //       }
    //     };

    //     fetchStatus();
    //   }, [startupId]);

    //   const handleChange = async (event) => {
    //     const newStatus = event.target.value;
    //     setUpdating(true);
    //     try {
    //       await axios.patch(`/api/startups/${startupId}/status`, { status: newStatus });
    //       setStatus(newStatus);
    //     } catch (err) {
    //       console.error("Error updating status", err);
    //     } finally {
    //       setUpdating(false);
    //     }
    //   };

    //   if (loading) return <CircularProgress size={24} />;

    const statusValue = isLoadingStatus ? null : data?.status;

    const handleSubmit = ({ payload }) => {
        // console.log(payload, "payload")
        updateStartupStatusAsync({
            payload: {
                "status": payload?.status,
            }
            , pipeline_id: data?.pipeline_id
        }).then((response) => {
            addToast(`Moved to ${statuses?.find(item => item?.value === payload?.status)?.label}`, "success")
            refetchListing();
            refetchStatus();
            handleCloseMenu();
        }).catch((error) => {

        })
    }

    return (
        <Box mb={0} sx={{ minWidth: 200 }}>
            {!isLoadingStatus && pipeline_status === "success" && <Chip label={<span style={{ display: "flex", alignItems: 'center', justifyContent: 'center', gap: 10 }}> <span>
                {statuses?.find(item => item?.value === statusValue)?.label}
            </span>
                {isLoadingStatus || isUpdatingStartupStatus ?
                    <CircularProgress size={"0.8rem"} sx={{
                        color: "black"
                    }} /> :
                    <KeyboardArrowDown />}
            </span>} style={{ borderRadius: '4px', marginBottom: '-1rem' }} clickable onClick={(e) => {
                handleOpenMenu(e);
                // console.log(e.currentTarget)
            }} />}

            {/* <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}

            >
                {statuses?.map((option) => (
                    <MenuItem value={option?.value}>{option?.label}</MenuItem>
                ))}
            </Menu> */}
            {!isLoadingStatus && <Select
                name="status"
                value={statusValue}
                onChange={(event) => {
                    const newStatus = event.target.value;
                    // console.log(newStatus, "newStatus")
                    handleSubmit({
                        payload: {
                            status: newStatus
                        }
                    })
                }}
                open={openChangeStatus}
                onClose={handleCloseMenu}
                onOpen={handleOpenMenu}
                // placeholder={placeholders?.status}
                sx={{
                    marginBottom: "0rem",
                    visibility: 'hidden',
                    height: "0px",
                    "& > #mui-component-select-status": { padding: "0.5rem", bgcolor: "#ffffff", border: "1px solid #a1a3a7", borderRadius: '8px' }, "& > fieldset.MuiOutlinedInput-notchedOutline": { border: "none" }
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            // Style the dropdown container (ul wrapper)
                            maxHeight: 300,
                            // bgcolor: "lightgray",
                            marginTop: "0.3rem",
                            "& ul": {
                                // padding: 0,
                                // margin: 0,
                                // backgroundColor: "white",
                            },
                            // "& li": {
                            //     fontSize: "14px",
                            //     color: "black",
                            // },
                        },
                    },
                }}
                fullWidth
            >
                {statuses?.filter(item => item?.value !== statusValue)?.map((option, index) => (
                    <MenuItem value={option?.value}>{option?.label}</MenuItem>
                ))}
            </Select>}
            {/* {console.log(statuses)} */}


            {/* <Dialog maxWidth="xs" open={Boolean(openChangeStatus)} onClose={handleCloseMenu} aria-labelledby="update-Status-dialog" sx={{ "& > .MuiDialog-container > .MuiPaper-root": { width: "100%", borderRadius: "8px" } }}>
                <StatusChange handleClose={handleCloseMenu} handleSubmit={handleSubmit} isLoading={isUpdatingStartupStatus} selectedStartupId={startupId} statusValue={statusValue} statuses={statuses} />
            </Dialog> */}

        </Box>
    );
}
